import { FieldValidator } from 'final-form';
import { Field } from 'react-final-form';
import { CheckboxGroup } from '@tcl-boron-prefabs/checkbox-group';
import { Checkbox } from '@tcl-boron-prefabs/checkbox';

interface FormCheckboxGroupProps {
  label: string;
  name: string;
  options: { label: string; value: string }[];
  validate?: FieldValidator<string[]>;
}

const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({ label, name, options, validate }) => {
  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => (
        <CheckboxGroup
          label={label}
          value={input.value}
          onChange={(value) => {
            input.onChange(value);
          }}
          subContent={meta.error && meta.touched ? meta.error : null}
          data-testid={name}
        >
          {options.map((option) => (
            <Checkbox label={option.label} value={option.value} key={option.value} />
          ))}
        </CheckboxGroup>
      )}
    </Field>
  );
};

export default FormCheckboxGroup;
